import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import {
  GlgTooltipIcon,
} from 'SharedComponents'
import RegStatusComponent from './reg_status_component'
import LinksComponent from './links_component'
import DatesComponent from './dates_component'
import _ from 'lodash'
// import FaIcon from 'react-fa'

import { handleRowClick } from 'Shared/helpers'
// import PopupTypes from '../popup_types'

const EventCondensedItemComponent = ({
  name, startDate, tourName, courses, registrationInfo, showRegistrationColumns, GGIDGuestLoginURL, registered, index, logo,
  hasCartship, websiteMultiRegistrationCartURL, condition1, condition2, condition3, condition4, conditionForCart, leagueMultiEventsRegistration, addToCartPath,
  MRMember, registerPath, bookNowPath, hasOpenTeeTimes, hasBookingAfterRegister, product, registrationTypes, id, cartCartshipPath, cartCondition, cartConditionWithInclude, widgetsMPPath, teeSheetPath, resultsPath, addToCart,
  idsForLabels, willBeWaitlisted, willBePending, willBeDisabled, registrationWithPayments, cartMerchantAccountId, cartMerchantAccountType, shouldHideRegistration, statusFilter, endDate, showCourseInfo, waitlist, exemptionEventLink,
  datesToSort, hasEnteredLottery, customerTimeFormat
}) => {
  
  let zebraClass
  index % 2 === 0 ? zebraClass = ' white-row' : zebraClass = ' grey-row'
  
  const linksProps = {
    hasCartship: hasCartship,
    websiteMultiRegistrationCartURL: websiteMultiRegistrationCartURL,
    condition1: condition1,
    condition2: condition2,
    condition3: condition3,
    condition4: condition4,
    conditionForCart: conditionForCart,
    leagueMultiEventsRegistration: leagueMultiEventsRegistration,
    GGIDGuestLoginURL: GGIDGuestLoginURL,
    MRMember: MRMember,
    registerPath: registerPath,
    bookNowPath: bookNowPath,
    hasOpenTeeTimes: hasOpenTeeTimes,
    hasBookingAfterRegister: hasBookingAfterRegister,
    product: product,
    registrationTypes: registrationTypes,
    id: id,
    cartCartshipPath: cartCartshipPath,
    cartCondition: cartCondition,
    cartConditionWithInclude: cartConditionWithInclude,
    eligibilityMessage: registrationInfo.eligibility_message,
    showLinkToRenew: registrationInfo.show_link_to_renew,
    status: registrationInfo.status,
    widgetsMPPath: widgetsMPPath,
    teeSheetPath: teeSheetPath,
    resultsPath: resultsPath,
    onClick: addToCart,
    addToCartPath: addToCartPath,
    willBeWaitlisted: willBeWaitlisted,
    willBePending: willBePending,
    willBeDisabled: willBeDisabled,
    registrationWithPayments: registrationWithPayments,
    merchantAccountId: registrationInfo.merchant_account_id,
    merchantAccountTypeAccount: registrationInfo.merchant_account_type_account,
    cartMerchantAccountId: cartMerchantAccountId,
    cartMerchantAccountType: cartMerchantAccountType,
    startDate: startDate,
    exemptionEventLink: exemptionEventLink,
    shouldHideRegistration: shouldHideRegistration,
  }

  // const statusText = {
  //   registered: 'My registrations',
  //   Open: 'Open Registration',
  //   Closed: 'Closed Registration',
  // }

  const [ isHovered, setIsHovered ] = useState(false)

  const onRowClick = (event) => {
    handleRowClick(event, shouldHideRegistration, linksProps.resultsPath)
  }

  const handleMouseEnter = () => {
    if (shouldHideRegistration) {
      setIsHovered(true)
    }
  }

  const handleMouseLeave = () => {
    if (shouldHideRegistration) {
      setIsHovered(false)
    }
  }
  
  let displayMyRegistrations = true
  if (statusFilter) {
    statusFilter.includes('my_registrations') ? displayMyRegistrations = true : displayMyRegistrations = false
  }

  let hideRegistration = ''
  if (shouldHideRegistration) {
    hideRegistration += ' hidden'
  }
  
  return (
    <div>
      <div>
        { idsForLabels[id] && MRMember && displayMyRegistrations && (
          <div className='page_title add-padding-top-10 font-size-14 labels-margin-xs'>
            <div className='text'>
              {idsForLabels[id] === 'registered' ? !window.I18n ? '' : window.I18n.t('customer_directories.condensed_view.my_registrations') : !window.I18n ? '' : window.I18n.t('customer_directories.condensed_view.all_events')}
            </div>
          </div>
        )}
      </div>
      <table className='table table-hover table-striped table-condensed table-bordered customer_directory_table'>
        <tbody className='render_directories_table'>
          <tr className={zebraClass + ' tr-content'}>
            {registrationInfo.status === '' && (
              <td className={'empty-reg-status reg-status' + hideRegistration} rowSpan={1}></td>
            )}
            {showRegistrationColumns && registrationInfo.status && (
              <RegStatusComponent
                registered={registered}
                waitlist={waitlist}
                status={registrationInfo.status}
                endsAt={registrationInfo.ends_at}
                startsAt={registrationInfo.starts_at}
                invStartsAt={registrationInfo.can_inv_list ? registrationInfo.inv_starts_at : ''}
                openingDates={registrationInfo.can_membership_programs ? registrationInfo.memberships_info.map(m => m.start_date) : []}
                timezone={registrationInfo.time_zone}
                rowSpan={1}
                lotteryStartsAt={registrationInfo.lottery_starts_at}
                lotteryEndsAt={registrationInfo.lottery_ends_at}
                hasEnteredLottery={hasEnteredLottery}
                shouldHideRegistration={shouldHideRegistration}
                customerTimeFormat={customerTimeFormat} />
            )}
            {logo && (
              <td rowSpan={1} className={`visible-xs no-border-right hide-logo ${shouldHideRegistration ? `clickable ${isHovered ? 'hover' : ''}` : ''}`} onClick={onRowClick} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                <Col>
                  <div>
                    <div className='logo'>
                      <a href={shouldHideRegistration ? '#' : GGIDGuestLoginURL} className={`${shouldHideRegistration ? 'no_hover' : ''}`} target={'_blank'}>
                        <img src={logo} className="img-responsive logo-img" style={{minHeight: '75px', maxHeight: '85px'}} />
                      </a>
                    </div>
                  </div>
                </Col>
              </td>
            )}
            <td className={`condensed ${shouldHideRegistration ? `clickable info-width ${isHovered ? 'hover' : ''}` : ''} ${logo ? 'logo no-border-left' : ''}`}
                colSpan="2" onClick={onRowClick} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
              <Row>
                {logo && (
                  <Col md={1}>
                    <div className='hidden-xs'>
                      <div className='logo'>
                        <a href={shouldHideRegistration ? '#' : GGIDGuestLoginURL} className={`${shouldHideRegistration ? 'no_hover' : ''}`} target={'_blank'}>
                          <img src={logo} className="img-responsive logo-img" style={{maxHeight: '85px'}} />
                        </a>
                      </div>
                    </div>
                  </Col>
                )}
                <Col xs={12} md={logo ? 11 : 12}>
                  <Row className={'date-container'}>
                    <Col xs={12} md={8} sm={8}>
                      <div className='information'>
                        <a href={shouldHideRegistration ? '#' : GGIDGuestLoginURL} className={`league-name ${shouldHideRegistration ? 'no_hover' : ''}`} target={'_top'}>
                          <b>
                            {name}
                          </b>
                        </a>
                      </div>
                    </Col>
                    <Col className={`hidden-xs ${shouldHideRegistration ? 'align-date-text' : 'hidden'}`}>
                      <span className='information inline-box'>
                        <DatesComponent startDate={startDate} endDate={endDate} datesToSort={datesToSort} mode={1} />
                        {tourName && (
                          <span className='inline-box'>
                            <div>
                              <div className='circle_divider'></div>
                            </div>
                            <div className='font-size-14'>
                              <span title={tourName}>
                                {_.truncate(tourName, {'length': 17})}
                              </span>
                            </div>
                          </span>
                        )}
                      </span>
                    </Col>
                    <Col xs={12} ls={4} md={4} sm={4} className={`${hideRegistration}`}>
                      <div className='links registration_links_container text-right hidden-xs'>
                        <LinksComponent linksProps={linksProps} status={registrationInfo.status} />
                      </div>
                    </Col>
                  </Row>
                  <Row className={shouldHideRegistration ? 'date-container' : ''}>
                    <Col className={`hidden-xs ${shouldHideRegistration ? 'hidden' : 'align-date-text add-margin-top-5'}`}>
                      <span className='information inline-box dates-padding-0'>
                        <DatesComponent startDate={startDate} endDate={endDate} datesToSort={datesToSort} mode={0} />
                        {tourName && (
                          <span className='inline-box'>
                            <div>
                              <div className='circle_divider'></div>
                            </div>
                            <div className='font-size-14'>
                              <span title={tourName}>
                                {_.truncate(tourName, {'length': 17})}
                              </span>
                            </div>
                          </span>
                        )}
                      </span>
                    </Col>
                  </Row>
                  <Row className={shouldHideRegistration ? 'date-container' : ''}>
                    {showCourseInfo && shouldHideRegistration && (
                      <Col xs={12} md={tourName ? 5 : 7} className='non-xs add-margin-top-10'>
                        <div className='information font-size-14'>
                          {(courses.length <= 2) ? 
                            (
                              <Fragment>
                                {courses[0]}
                                {courses[1] && (
                                  <Fragment>
                                    <div className='circle_divider'></div>
                                    {courses[1]}
                                  </Fragment>
                                )}
                              </Fragment>
                            ) : (
                              <Fragment>
                                { !window.I18n ? '' : window.I18n.t('customer_directories.event.multiple_courses') }
                                <GlgTooltipIcon tooltip={courses.join('\n')} tooltipClass="custom-tooltip" />
                              </Fragment>
                            )
                          }
                          { courses.join(' ● ').length > (tourName ? 68 : 90) && courses.length <= 2 && (
                              <GlgTooltipIcon tooltip={courses.join(', ')} tooltipClass="custom-tooltip" />
                          )}
                        </div>
                      </Col>
                    )}
                    <Col className={`hidden-xs align-date-text non-xs add-margin-top-10 ${!shouldHideRegistration ? 'hidden' : ''}`}>
                      <span className='information inline-box'>
                        <DatesComponent startDate={startDate} endDate={endDate} datesToSort={datesToSort} mode={2} />
                        {tourName && (
                          <span className='inline-box'>
                            <div>
                              <div className='circle_divider'></div>
                            </div>
                            <div className='font-size-14'>
                              <span title={tourName}>
                                {_.truncate(tourName, {'length': 17})}
                              </span>
                            </div>
                          </span>
                        )}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={2} className={'visible-xs add-margin-top-5'}>
                      <span className='information inline-box'>
                        <DatesComponent startDate={startDate} endDate={endDate} datesToSort={datesToSort} />
                        {tourName && (
                          <span className='inline-box'>
                            <div>
                              <div className='circle_divider'></div>
                            </div>
                            <div className='font-size-14'>
                              <span title={tourName}>
                                {_.truncate(tourName, {'length': 17})}
                              </span>
                            </div>
                          </span>
                        )}
                      </span>
                    </Col>
                    {tourName && (
                      <Col xs={12} md={2} className={'hidden-xs add-margin-top-10'}>
                        <div className='information font-size-14'>
                          <span title={tourName}>
                            {_.truncate(tourName, {'length': 17})}
                          </span>
                        </div>
                      </Col>
                    )}
                    {showCourseInfo && !shouldHideRegistration && (
                      <div xs={12} md={tourName ? 5 : 7} className={`hidden-xs non-xs add-margin-top-10 visible-xs ${!shouldHideRegistration ? 'align-course-info-1' : ''}`}>
                        <div className='information font-size-14'>
                          {(courses.length <= 2) ? 
                            (
                              <Fragment>
                                {courses[0]}
                                {courses[1] && (
                                  <Fragment>
                                    <div className='circle_divider'></div>
                                    {courses[1]}
                                  </Fragment>
                                )}
                              </Fragment>
                            ) : (
                              <Fragment>
                                { !window.I18n ? '' : window.I18n.t('customer_directories.event.multiple_courses') }
                                <GlgTooltipIcon tooltip={courses.join('\n')} tooltipClass="custom-tooltip" />
                              </Fragment>
                            )
                          }
                          { courses.join(' ● ').length > (tourName ? 68 : 90) && courses.length <= 2 && (
                              <GlgTooltipIcon tooltip={courses.join(', ')} tooltipClass="custom-tooltip" />
                          )}
                        </div>
                      </div>
                    )}
                    {showCourseInfo && !shouldHideRegistration && (
                      <div xs={12} md={tourName ? 5 : 7} className={`visible-xs non-xs add-margin-top-10 ${!shouldHideRegistration ? 'align-course-info-2' : ''}`}>
                        <div className='information font-size-14'>
                          {(courses.length <= 2) ? 
                            (
                              <Fragment>
                                {courses[0]}
                                {courses[1] && (
                                  <Fragment>
                                    <div className='circle_divider'></div>
                                    {courses[1]}
                                  </Fragment>
                                )}
                              </Fragment>
                            ) : (
                              <Fragment>
                                { !window.I18n ? '' : window.I18n.t('customer_directories.event.multiple_courses') }
                                <GlgTooltipIcon tooltip={courses.join('\n')} tooltipClass="custom-tooltip" />
                              </Fragment>
                            )
                          }
                          { courses.join(' ● ').length > (tourName ? 68 : 90) && courses.length <= 2 && (
                              <GlgTooltipIcon tooltip={courses.join(', ')} tooltipClass="custom-tooltip" />
                          )}
                        </div>
                      </div>
                    )}
                  </Row>
                  {exemptionEventLink && (
                    <div>
                      <span className={`${hideRegistration}`}>
                        { !window.I18n ? '' : `${window.I18n.t('customer_directories.event.exempt')} ` }
                        <a href={exemptionEventLink} target={'_top'}>
                          { !window.I18n ? '' : window.I18n.t('customer_directories.event.here') }
                        </a>
                      </span>
                    </div>
                 )}
                  <div className={`${hideRegistration}`}>
                    <div className='pull-right'>
                      <div className='links registration_links_container non-xs add-margin-top-15 visible-xs'>
                        <LinksComponent linksProps={linksProps} status={registrationInfo.status} />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </td>
          </tr>
          <tr className='tr-content height-10 empty-row'></tr>
        </tbody>
      </table>
    </div>
  )
}

EventCondensedItemComponent.propTypes = {
  name: PropTypes.string.isRequired,
  startDate: PropTypes.string,
  tourName: PropTypes.string,
  courses: PropTypes.array,
  registrationInfo: PropTypes.object,
  showRegistrationColumns: PropTypes.bool,
  GGIDGuestLoginURL: PropTypes.string,
  registered: PropTypes.bool,
  index: PropTypes.number,
  hasCartship: PropTypes.bool,
  websiteMultiRegistrationCartURL: PropTypes.string,
  condition1: PropTypes.bool,
  condition2: PropTypes.bool,
  condition3: PropTypes.bool,
  condition4: PropTypes.bool,
  conditionForCart: PropTypes.bool,
  leagueMultiEventsRegistration: PropTypes.bool,
  MRMember: PropTypes.object,
  registerPath: PropTypes.string,
  bookNowPath: PropTypes.string,
  hasOpenTeeTimes: PropTypes.bool,
  hasBookingAfterRegister: PropTypes.bool,
  product: PropTypes.string,
  registrationTypes: PropTypes.array,
  id: PropTypes.string,
  cartCartshipPath: PropTypes.string,
  cartCondition: PropTypes.bool,
  cartConditionWithInclude: PropTypes.bool,
  widgetsMPPath: PropTypes.string,
  logo: PropTypes.string,
  resultsPath: PropTypes.string,
  teeSheetPath: PropTypes.string,
  addToCart: PropTypes.func,
  addToCartPath: PropTypes.string,
  idsForLabels: PropTypes.object,
  willBeWaitlisted: PropTypes.bool,
  willBePending: PropTypes.bool,
  willBeDisabled: PropTypes.bool,
  registrationWithPayments: PropTypes.bool,
  cartMerchantAccountId: PropTypes.string,
  cartMerchantAccountType: PropTypes.string,
  statusFilter: PropTypes.array,
  endDate: PropTypes.string,
  showCourseInfo: PropTypes.bool,
  waitlist: PropTypes.string,
  exemptionEventLink: PropTypes.string,
  datesToSort: PropTypes.string,
  hasEnteredLottery: PropTypes.bool,
  shouldHideRegistration: PropTypes.bool,
  customerTimeFormat: PropTypes.string,
}

EventCondensedItemComponent.defaultProps = {
}

export default EventCondensedItemComponent
